export default __webpack_public_path__ + "media/images/favicon-cb44021bb92c7f525b6769dab7fc9b29.ico";